import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // 디자인을 위해 필요합니다
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
